import produce from 'immer';
import initialState from './initialState';
/* eslint-disable no-param-reassign */

var cellInfoFocus = produce(function (draft, action) {
  var _action$payload = action.payload,
    store = _action$payload.store,
    layer = _action$payload.layer,
    _action$payload$optio = _action$payload.options,
    options = _action$payload$optio === void 0 ? {} : _action$payload$optio;
  draft.focus[layer] = {
    store: store,
    options: options
  };
}, initialState);
export default cellInfoFocus;